<template>
  <div id="bar" class="flex items-center justify-between p-4 text-white border-b-2 border-black">
    <div class="flex flex-row">
      <h1 class="mr-8">Amigos</h1>
      <router-link to="/">Dashboard</router-link>
    </div>
    <slot />
  </div>
</template>